import { HTMLAttributes } from 'react';
import { BsCheckCircle } from 'react-icons/bs';
import { ButtonType, TAButton } from '../widgets';
import { useTheme } from 'styled-components';

interface IServiceCardProps {
	title: string;
	services: string[];
	actionLink: string;
}

export const ServiceCard: React.FC<HTMLAttributes<HTMLDivElement> & IServiceCardProps> = ({
	title,
	services,
	actionLink
}) => {
	const theme = useTheme();
	return (
		<div style={{ padding: '1.5rem', backgroundColor: '#fff' }}>
			<h5 style={{ marginBottom: '1rem' }}>{title}</h5>
			<span
				style={{
					fontSize: '1rem',
					fontWeight: '500',
					display: 'inline-block',
					marginBottom: '1rem',
					color: '#000'
				}}
			>
				Includes:
			</span>
			{services.map(service => (
				<>
					<div className="d-flex align-items-center mb-3">
						<BsCheckCircle size={25} color={theme.PRIMARY_COLOR} className="me-2" />
						{service}
					</div>
				</>
			))}
			<TAButton width="100%" btntype={ButtonType.PRIMARY}>
				<a target="_blank" href={actionLink}>
					Book a call
				</a>
			</TAButton>
		</div>
	);
};
